import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, SubmitInput, Error, Success } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

const UnscheduleNotification: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleYesClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      notificationId: { value: string };
    };

    const notificationIdValue = target.notificationId.value;
    if (!notificationIdValue) {
      alert('Invalid input for notificationId');
      return;
    }

    setIsLoading(true);

    try {
      await callFunction('unscheduleMassNotification', {
        massNotificationId: notificationIdValue
      });
      setSuccess('Notification disabled');
    } catch (error: any) {
      console.error('Failed to unschedule notification:', error);
      setError(error?.message || error?.error || 'Failed to unschedule notification');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleYesClick}>
      <Input placeholder="Notification Id To disable" name="notificationId" />
      <SubmitInput type="submit" value={isLoading ? "Disabling..." : "Disable Notification"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { UnscheduleNotification };
